'use client';
import Image from 'next/image';
import useSelectImg from '@/hook/useSelectImg';

const TeamImg = () => {
  const teamJpg = '/og-default.jpg';
  const teamWebp = '/og-default.webp';
  const altText = 'Team Image';

  // Utilisation du hook pour sélectionner le bon format d'image
  const selectedImage = useSelectImg(teamJpg, teamWebp, undefined, teamJpg);

  return (
    <div className='img-wrap'>
      <Image src={selectedImage} alt={altText} width={800} height={600} priority className='img' />
    </div>
  );
};

export default TeamImg;
